var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 10,
    fill: "#E1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3125 16.5626L21.9062 15.375L23.0938 14.7813L21.9062 14.1875L21.3125 13L20.7188 14.1875L19.5312 14.7813L20.7188 15.375L21.3125 16.5626ZM15.9688 18.9376L16.9581 16.9585L18.9375 15.9688L16.9581 14.9791L15.9688 13L14.9794 14.9791L13 15.9688L14.9794 16.9585L15.9688 18.9376ZM29.0312 23.6877L28.0419 25.6668L26.0625 26.6565L28.0419 27.6462L29.0312 29.6253L30.0206 27.6462L32 26.6565L30.0206 25.6668L29.0312 23.6877ZM31.6519 16.4969L28.5032 13.3481C28.2716 13.1158 27.9677 13 27.6638 13C27.3598 13 27.0559 13.1158 26.824 13.3481L13.3481 26.8243C12.8842 27.2881 12.8842 28.04 13.3481 28.5035L16.4968 31.6523C16.7288 31.8842 17.0327 32 17.3362 32C17.6402 32 17.9441 31.8842 18.176 31.6523L31.6519 18.1757C32.1158 17.7126 32.1158 16.9604 31.6519 16.4969ZM26.339 20.5504L24.4497 18.6611L27.6634 15.4474L29.5526 17.3367L26.339 20.5504Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIcon2);
export default __webpack_public_path__ + "static/media/step_icon_2.6088de5bf0abbc9b855986a403310963.svg";
export { ForwardRef as ReactComponent };